import { render } from "./CreateWasiyyah.vue?vue&type=template&id=2ebb7855"
import script from "./CreateWasiyyah.vue?vue&type=script&lang=js"
export * from "./CreateWasiyyah.vue?vue&type=script&lang=js"

import "./CreateWasiyyah.vue?vue&type=style&index=0&id=2ebb7855&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__